import PlateBarcodeInput from './PlateBarcodeInput'

export default PlateBarcodeInput
